var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],staticClass:"chatbot-page"},[_c('funcionalidade-header',{attrs:{"titulo":_vm.tituloNavegacao}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatbot-container"},[_c('div',{attrs:{"id":"mosia-chat"}})])
}]

export { render, staticRenderFns }